module.exports = __webpack_public_path__ + "media/vectors/term-bg-7-21064e2b.jpg";